import {useEffect} from 'react';

export default function useEvent(eventName,callback){
    useEffect(() => {
        window.addEventListener(eventName, callback);
        return () => window.removeEventListener(eventName, callback);
    }, [eventName, callback]);
}